"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentageForMonthInTemplate = exports.percentagesForSeasonalityTemplate = exports.nextMonthDateRanges = exports.nameForPricingPeriodFromDate = exports.monthNameForIndex = void 0;
const seasonality_1 = require("./seasonality");
const diem_1 = __importDefault(require("@travelnest/diem"));
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const GENERATED_MONTHS = 24;
const monthNameForIndex = (monthIndex) => {
    return MONTHS[monthIndex];
};
exports.monthNameForIndex = monthNameForIndex;
const nameForPricingPeriodFromDate = (inputDate) => {
    return `${(0, exports.monthNameForIndex)(inputDate.getMonth())}-${inputDate.getFullYear()}`;
};
exports.nameForPricingPeriodFromDate = nameForPricingPeriodFromDate;
// Create date ranges for the input date's month and next 'idealPricingEndNumMonths'
const nextMonthDateRanges = (inputDate) => {
    const output = new Array(GENERATED_MONTHS);
    const cursor = new diem_1.default(inputDate);
    output[0] = { start_date: cursor.toISOString() };
    // 1st of current month
    for (let index = 0; index < GENERATED_MONTHS; index++) {
        cursor.setDate(1);
        if (index !== 0) {
            output[index] = { start_date: cursor.toISOString() };
        }
        cursor.setMonth(cursor.getMonth() + 1);
        cursor.setDate(cursor.getDate() - 1);
        output[index].end_date = cursor.toISOString();
        // Jump to next month
        cursor.setDate(cursor.getDate() + 1);
    }
    ;
    return output;
};
exports.nextMonthDateRanges = nextMonthDateRanges;
const percentagesForSeasonalityTemplate = (template) => {
    switch (template) {
        case seasonality_1.SeasonalityTemplate.FlatRate:
            return seasonality_1.flatSeasonality;
        case seasonality_1.SeasonalityTemplate.Quarterly:
            return seasonality_1.quarterlySeasonality;
        case seasonality_1.SeasonalityTemplate.Gradual:
            return seasonality_1.gradualSeasonality;
        case seasonality_1.SeasonalityTemplate.SummerPeak:
            return seasonality_1.summerPeakSeasonality;
        default:
            throw new Error('Unsupported seasonality template');
    }
};
exports.percentagesForSeasonalityTemplate = percentagesForSeasonalityTemplate;
const percentageForMonthInTemplate = (monthName, template) => {
    return (0, exports.percentagesForSeasonalityTemplate)(template)[monthName.toLowerCase()];
};
exports.percentageForMonthInTemplate = percentageForMonthInTemplate;
//# sourceMappingURL=pricing-generator-helpers.js.map